<!--
 * @Descripttion:
 * @Author: Niu Chenxin
 * @Date: 2021-01-14 17:52:57
 * @LastEditors: xuhuining
 * @LastEditTime: 2022-08-02 11:14:53
-->
<template>
  <div v-if="enlargeImgItem" class='calenImgMask' @click.stop="goBack" @touchmove.prevent @mousewheel.prevent>
    <!-- 返回按钮 -->
    <div class="back" @click.stop="goBack">
      <img alt="" class="backimg" src="../../../assets/images/icon/back1.png">
    </div>

    <div class="img_boxs">
      <div :style="{'height': (windowHeight- 60)+'px'}" class="img">
        <img :src="enlargeImgItem.imgUrl" alt="">
      </div>
      <div class='operation_block'>
        <div class="content_state">
          <div class="like state" @click.stop="likeClick(enlargeImgItem)">
            <img
                :src="enlargeImgItem.orLike?require('../../../assets/images/icon/like2.png'):require('../../../assets/images/icon/like_.png')"
                alt="">
            <span>{{ enlargeImgItem.like ? fomatterNum(enlargeImgItem.like) : 0 }}</span>
          </div>
          <div class="collect state" @click.stop="collectClick(enlargeImgItem)">
            <img
                :src="enlargeImgItem.orFavorites?require('../../../assets/images/icon/collect2.png'):require('../../../assets/images/icon/praise_.png')"
                alt="">
            <span>{{ enlargeImgItem.collect ? fomatterNum(enlargeImgItem.collect) : 0 }}</span>
          </div>
          <div class="share state" @click.stop='shareToast(enlargeImgItem)'>
            <img alt="" src="../../../assets/images/icon/share_.png">
            <span>{{ enlargeImgItem.share ? fomatterNum(enlargeImgItem.share) : 0 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 育儿日历图片放大
import {Debounce, fomatterNum, globalGoLogin} from "@/assets/js/common.js";
import API from '@/utils/axiosApi/calendarApi'

export default {
  data() {
    return {
      UserInfo: null,
      windowHeight: window.innerHeight
    }
  },
  props: {
    enlargeImgItem: {
      type: Object,
      default: null
    },
    ABtest: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    goBack() {
      this.$emit('enlargeImg', false);
    },
    fomatterNum,
    // 分享
    shareToast: Debounce(function (item) {
      const that = this;
      this.$toast({
        message: "可长按图片保存分享",
        duration: 2000
      })
      //   that.$emit('weShare', item.id)
      API.addShare({}, {id: item.id}, res => {
        if (res.code == '200') {
          that.enlargeImgItem.share += 1;
        }
      })
      sensors.track('Share', {
        'content_id': item.id,
        'content_title': '',
        'Column': '育儿日历',
        'Poster_Date': item.startDate,
        // 'A_B_flow': this.ABtest
      })
    }),
    // 点赞和取消点赞
    likeClick: Debounce(function (item) {
      if (!this.UserInfo || this.UserInfo.mobile == '' || this.UserInfo.mobile == null) {
        // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href });
        globalGoLogin()
      } else {
        const orLike = this.enlargeImgItem.orLike;
        const that = this;
        if (!orLike) {
          API.addLike({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.enlargeImgItem.like += 1;
              that.enlargeImgItem.orLike = true;
              that.$toast({
                duration: 2000,
                message: "点赞成功",
                context: that
              });
            }
          })
          sensors.track('Support', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        } else {
          API.cancelLike({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.enlargeImgItem.like -= 1;
              that.enlargeImgItem.orLike = false;
            }
          })
          sensors.track('Unsupport', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        }
      }
    }, 100),
    // 收藏和取消收藏
    collectClick(item) {
      if (!this.UserInfo || this.UserInfo.mobile == '' || this.UserInfo.mobile == null) {
        // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href });
        globalGoLogin()
      } else {
        const orFavorites = this.enlargeImgItem.orFavorites;
        const that = this;
        if (!orFavorites) {
          API.addCollect({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.enlargeImgItem.collect += 1;
              that.enlargeImgItem.orFavorites = true;
              that.$toast({
                duration: 2000,
                message: "收藏成功",
                context: that
              });
              if (that.type && that.type == 'collect') {
                that.$emit('deleteItem', true, item);
              }
            }
          })
          sensors.track('Save', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        } else {
          API.cancelCollect({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.enlargeImgItem.collect -= 1;
              that.enlargeImgItem.orFavorites = false;
              if (that.type && that.type == 'collect') {
                that.$emit('deleteItem', false, item);
              }
            }
          })
          sensors.track('CancelSave', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.calenImgMask {
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  // 返回按钮
  .back {
    width: 26px;
    height: 26px;
    position: fixed;
    top: 9px;
    left: 7px;
    z-index: 12;

    img {
      width: 26px;
    }
  }

  .img_boxs {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .img {
    max-height: 521px;
    margin: 0 auto;
    text-align: center;

    img {
      height: 100%;
    }
  }

  .content_state {
    width: 320px;
    overflow: hidden;
    margin: 0 auto;
    // padding-bottom: 20px;

    .state {
      width: 33.33%;
      text-align: center;
      font-size: 14px;
      color: #999999;
      line-height: 1;
      float: left;
      padding: 17px 0;

      img {
        width: 14px;
        height: 14px;
        margin-right: 3px;
        vertical-align: middle;
      }

      span {
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
